import Button from 'src/components/button/Button';
import theme from 'src/components/themes/DefaultTheme';
import styled from 'src/lib/styles/css';

//#region [Props]
type NextQuestionButtonProps = {
	doNextQuestion: () => void;
};
//#endregion

//#region [Component]
export default function NextQuestionButton({ doNextQuestion }: NextQuestionButtonProps) {
	return <SNextButton onClick={doNextQuestion} text='Neste spørsmål' />
}
//#endregion

//#region [Styles]
const SNextButton = styled(Button)`
	max-width: 400px;
	margin-left: auto;
	margin-right: auto;
	text-decoration: none;
	cursor: pointer;
    font-size: 20px;
    width: 100%;

	padding: 10px;
	background: ${theme.palette.lilla2};
    border-radius: 24px;
	font-weight: bold;
`;
//#endregion